/* eslint-disable import/prefer-default-export */
import * as AutocompleteQueryReducer from '@src/redux/reducers/autocomplete.query/default.state'
import { View } from '@src/utils/graph.helpers'
import { defaultState as defaultStateNetworking } from '../networking/default.state'
import type { NetworkTabs } from '@src/modules/networks/configurations/details.configurations/tabs.configurations'
import type { NetworkTiles } from '@src/modules/networks/configurations/details.configurations/tiles.configurations'
import {
  ResourceTypeEnum,
  SearchResultTableRow_TotalActionsEntry,
  SearchResultTableRow_UsedActionsEntry
} from '@src/endpoints/services/commonHdr.service'
import type {
  NetworkSummaryInfo,
  InstanceRoleDetails
} from '@src/endpoints/services/graphQueryMgr.service'
import type { ParseCamURIResp } from '@src/utils/url.utils'
import type { InfoDetailsResult } from '@src/utils/resource.utils'

export interface Info extends InfoDetailsResult {
  OpenPorts?: string[]
  NotInCloudPlatformScope?: boolean[]
}

export interface InstanceRole extends InstanceRoleDetails {
  entity_type?: ResourceTypeEnum
  total_actions?: SearchResultTableRow_TotalActionsEntry
  used_actions?: SearchResultTableRow_UsedActionsEntry
  actions_str?: string
}
export type NetworkTotals = { [key in ResourceTypeEnum]?: number }
export interface NetworkSummaryItem
  extends NetworkSummaryInfo,
    ParseCamURIResp {
  account_name?: string
  object_type?: string
}

export const defaultState = {
  totals: {} as NetworkTotals,
  overviewList: [] as NetworkSummaryItem[],
  details: {
    info: {
      Name: [] as string[]
    } as Info,
    instanceRoleList: [] as InstanceRole[],
    networking: defaultStateNetworking,
    selectedTile: null as NetworkTiles,
    selectedTab: null as NetworkTabs,
    selectedCounter: '' as string,
    userCounts: 0,
    adminCounts: 0,
    groupCounts: 0,
    roleCounts: 0,
    serviceCounts: 0,
    policyCounts: 0,
    alertCounts: 0,
    networkCounts: 0,
    objectCounts: {
      used: 0,
      total: 0
    },
    membershipCounts: {
      roles: 0,
      rolesUsed: 0
    },
    networkingCounts: {
      instancesCnt: 0,
      securityGroupsCnt: 0,
      subnetsCnt: 0,
      sgRulesCnt: 0,
      routesCnt: 0
    },
    ...AutocompleteQueryReducer.defaultState
  },
  isPending: true,
  errors: null as any,
  selectedGraphView: View.access,
  selectedNetwork: ResourceTypeEnum.VPC
}

export type NetworksState = typeof defaultState
